import { useState } from "react";
import {
  BussinessHomeCardData,
  SubscriptionType,
} from "../pages/BussinessHomePage";
import {
  add,
  addOutline,
  cart,
  close,
  logoWhatsapp,
  pencil,
  removeOutline,
  trash,
} from "ionicons/icons";
import "./styles/VariantPricing.css";
import { IonButton, IonHeader, IonIcon, IonModal } from "@ionic/react";
import { bhpEditLinks, rupeeSymbol } from "../types/constants";
import ContentWithBackground from "../UI/ContentWithBackground";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { useHistory } from "react-router";
import { getSessionDetails } from "../common/cookies";
import { AdvanceCustomizationType, CartItemTypes } from "../types/data_types";

const VariantPricingSelModal: React.FC<{
  isOpen: boolean;
  onDismiss: () => void;
  subscriptionType: SubscriptionType;
  disablePriceDisplay: boolean;
  data: BussinessHomeCardData;
  cartItems: CartItemTypes[];
  addOrderItemized?: (name: string) => void;
  isMarket: boolean;
  id?: number | string;
  addRemoveCartCallBack: Function;
  OpenVarientModel?: Function;
  marketShowPrice?: boolean;
  buttonOverride?: {
    name?: string;
    onClick?: (id: string | number) => void;
    icon?: any;
  };
  entityId: string | number;
  advanceCustomization: AdvanceCustomizationType;
}> = (props) => {
  return (
    <IonModal
      isOpen={props.isOpen}
      // className="bhp-expanding-card-modal-size"
      initialBreakpoint={0.5}
      breakpoints={[0.5, 1]}
      onDidDismiss={props.onDismiss}
    >
      <IonHeader>
        <div
          style={{
            paddingTop: "15px",
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <IonButton
            fill="clear"
            color={"danger"}
            onClick={() => {
              props.onDismiss();
            }}
          >
            <IonIcon icon={close} slot="start" />
            Dismiss
          </IonButton>
        </div>
      </IonHeader>
      <ContentWithBackground>
        {props.data?.variant?.map((el, idx) => {
          return (
            <div key={idx} style={{ padding: "10px" }}>
              <VariantPricing
                entityId={props.entityId}
                subscriptionType={props.subscriptionType}
                disablePriceDisplay={props.disablePriceDisplay}
                isVarientMode={true}
                variantName={el.option}
                index={idx}
                data={props.data}
                cartItems={props.cartItems}
                addOrderItemized={props.addOrderItemized}
                isMarket={props.isMarket}
                id={props.id}
                addRemoveCartCallBack={props.addRemoveCartCallBack}
                OpenVarientModel={props.OpenVarientModel}
                buttonOverride={props.buttonOverride}
                marketShowPrice={props.marketShowPrice}
                advanceCustomization={props.advanceCustomization}
              />
            </div>
          );
        })}
      </ContentWithBackground>
      {/* <IonFooter>
        <IonButton expand="full" onClick={closeVarientSel} color={"primary"}>
          Continue Shopping{" "}
        </IonButton>
      </IonFooter> */}
    </IonModal>
  );
};

const VariantPriceDisplay: React.FC<{
  color?: "white";
  size?: "large" | "normal";
  price: number;
  listPrice: number;
  listModeListing?: boolean | number;
  unit: string | number;
  subscriptionType: SubscriptionType;
  disablePriceDisplay?: boolean;
  bhpEditLinks?: any;
  showUnitListMode?: boolean;
  unitStringOverride?: string;
  advanceCustomization: AdvanceCustomizationType;
}> = (props) => {
  const hasDiscount =
    !!props?.listPrice && !!props?.price && props.listPrice > props.price;
  const discountJsx = (
    <span
      style={{
        padding: "2px 5px",
        fontSize: props?.size === "large" ? "0.8rem" : "0.6rem",
        background:
          props?.color === "white"
            ? "yellow"
            : props.listModeListing
            ? "var(--ion-color-medium)"
            : "var(--ion-color-bhp-vypzee-dark)",
        color: props?.color === "white" ? "var(--ion-color-dark)" : "white",
        borderRadius: "2px",
        bottom: "2px",
        marginLeft:
          props.listModeListing && props.subscriptionType !== "PHYSICAL-MENU"
            ? "5px"
            : "5px",
        position: "relative",
      }}
    >
      {Math.round(((props?.listPrice - props?.price) / props?.listPrice) * 100)}
      % off
    </span>
  );
  // console.log("Price ", props?.price, " Unit ", props?.unit);
  if (!props?.price && !props?.unit) return <></>;
  return (
    <div>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          paddingTop: props.listModeListing ? "5px" : 0,
          userSelect: "none",
        }}
      >
        {!!(props.price || props.unit) && (
          <div style={{ display: "flex", marginRight: "5px" }}>
            {/* <div>&#8377; </div> */}

            <div
              style={{
                display: !!props.listModeListing ? "flex" : "block",
                alignItems: "center",
              }}
            >
              {hasDiscount && (
                <div
                  style={{
                    fontSize: props?.size === "large" ? "1rem" : "0.8rem",
                    color: props?.color ? "lightgray" : "gray",
                  }}
                >
                  {!!props.listPrice &&
                    props.subscriptionType !== "PHYSICAL-MENU" && (
                      <>
                        {rupeeSymbol}
                        <span
                          style={{
                            textDecoration: "line-through",
                            paddingRight: props.listModeListing ? "5px" : "0",
                          }}
                        >
                          {props.listPrice}
                        </span>
                      </>
                    )}
                  {!props.listModeListing && discountJsx}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  fontSize: props?.size === "large" ? "1.2rem" : "0.8rem",
                  color:
                    props?.color === "white"
                      ? "white"
                      : "var(--ion-color-dark)",
                }}
              >
                {!(
                  props.subscriptionType === "CATALOGUE" ||
                  props.subscriptionType === "PHYSICAL-MENU"
                ) &&
                  !props.disablePriceDisplay &&
                  !!props.price && (
                    <>
                      {rupeeSymbol}
                      {props.price}
                    </>
                  )}
                {!!props.unit &&
                  (!props.listModeListing || props?.showUnitListMode) && (
                    <div
                      style={{
                        marginLeft:
                          !props.disablePriceDisplay && !!props.price
                            ? "2px"
                            : undefined,
                      }}
                    >
                      {`${
                        props?.unitStringOverride
                          ? props.unitStringOverride
                          : "per"
                      } `}
                      {props.unit}
                    </div>
                  )}
              </div>
              {!!props.listModeListing && hasDiscount && discountJsx}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

const VariantPricing: React.FC<{
  disablePadding?: boolean;
  disablePriceDisplay?: boolean;
  subscriptionType?: SubscriptionType;
  isVarientMode: boolean;
  variantName?: string;
  data: BussinessHomeCardData;
  cartItems: CartItemTypes[];
  index: number;
  addOrderItemized?: (name: string) => void;
  isMarket: boolean;
  id?: number | string;
  addRemoveCartCallBack: Function;
  openCloseCard?: Function;
  openCart?: Function;
  OpenVarientModel?: Function;
  listModeListing?: boolean | number;
  buttonOverride?: {
    name?: string;
    onClick?: (id: string | number) => void;
    icon?: any;
  };
  marketShowPrice?: boolean;
  size?: "large" | "normal";
  color?: "white";
  entityId: string | number;
  bhpEditLinks?: any;
  advanceCustomization: AdvanceCustomizationType;
}> = (props) => {
  const cartItem = props.cartItems?.find((ci) => {
    if (!props.isVarientMode) {
      return ci.id === props.id;
    } else {
      if (ci.variantName) {
        return (
          ci.id === props.id &&
          ci.variantName === props.data.variant[props.index].option
        );
      } else {
        return ci.id === props.id;
      }
    }
  });

  const cartItemTotalCount = props.cartItems?.filter((ci) => {
    return ci.id === props.id;
  });
  const totalCount = cartItemTotalCount?.reduce(
    (sum, obj) => sum + obj.count,
    0
  );

  const requestCartItemJsx = (
    <>
      <div
        className="add-more-to-cart-btn"
        style={{
          display: "flex",
          alignItems: "center",
          fontWeight: "normal",
          fontSize: props?.size === "large" ? "1.2rem" : undefined,
          background: props?.color === "white" ? "lightgray" : undefined,
          width:
            props?.data?.variant?.length &&
            (!!props?.data?.variant[props.index]?.price ||
              !!props?.data?.variant[props.index]?.unit)
              ? props?.size === "large"
                ? "150px"
                : "70px"
              : "100%",
        }}
      >
        <div
          onClick={(e) => {
            e.stopPropagation();
            if (!props.isVarientMode && props.data.variant.length > 1) {
              props.OpenVarientModel();
            } else {
              props.addRemoveCartCallBack(
                "remove",
                true,
                props.id,
                props.isVarientMode
                  ? props.data?.variant[props.index].option
                  : "",
                props.data?.variant[props.index].price
              );
            }
          }}
          style={{ paddingRight: "5px" }}
        >
          <IonIcon icon={removeOutline} color="secondary" />
        </div>
        <div>{props.subscriptionType === "TIER-II" ? "Added" : "Queried"}</div>
      </div>
    </>
  );

  const editModeBhp = useAppSelector(
    (state) => state.loginInfoSelection.bhpEditMode
  );

  const addCartItemJsx = (
    <>
      <div
        className="add-more-to-cart-btn"
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontWeight: "normal",
          fontSize: props?.size === "large" ? "1.2rem" : undefined,
          background: props?.color === "white" ? "lightgray" : undefined,
          width:
            props?.data?.variant?.length &&
            (!!props?.data?.variant[props.index]?.price ||
              !!props?.data?.variant[props.index]?.unit)
              ? props?.size === "large"
                ? "150px"
                : "70px"
              : "100%",
          userSelect: "none",
        }}
      >
        <div
          onClick={(e) => {
            e.stopPropagation();
            if (!props.isVarientMode && props.data.variant.length > 1) {
              props.OpenVarientModel();
            } else {
              props.addRemoveCartCallBack(
                "remove",
                true,
                props.id,
                props.isVarientMode
                  ? props.data.variant[props.index].option
                  : "",
                props.data.variant[props.index].price
              );
            }
          }}
          style={{ padding: "5px", flexShrink: 0 }}
        >
          <IonIcon icon={removeOutline} />
        </div>
        <div style={{ flexShrink: 0 }}>
          {props.isVarientMode === true && <> {cartItem?.count}</>}
          {props.isVarientMode === false && <>{totalCount}</>}
        </div>
        <div
          onClick={(e) => {
            e.stopPropagation();
            if (!props.isVarientMode && props.data.variant.length > 1) {
              props.OpenVarientModel();
            } else {
              props.addRemoveCartCallBack(
                "add",
                false,
                props.id,
                props.isVarientMode
                  ? props.data.variant[props.index].option
                  : "",
                props.data.variant[props.index].price
              );
            }
          }}
          style={{ padding: "5px", flexShrink: 0 }}
        >
          <IonIcon icon={addOutline} />
        </div>
      </div>
    </>
  );

  const priceJsx = (
    <VariantPriceDisplay
      size={props.size}
      color={props.color}
      disablePriceDisplay={props.disablePriceDisplay}
      subscriptionType={props.subscriptionType}
      price={
        props.data?.variant?.length ? props.data.variant[props.index]?.price : 0
      }
      listPrice={
        props.data?.variant?.length
          ? props.data.variant[props.index]?.listPrice
          : 0
      }
      unit={
        props.data?.variant?.length ? props.data.variant[props.index]?.unit : 0
      }
      listModeListing={props.listModeListing}
      advanceCustomization={props.advanceCustomization}
    />
  );
  const history = useHistory();
  const price = props.data?.variant?.length ? props.data.variant[0]?.price : 0;

  const buttonJsx = (
    <div
      style={{
        flexGrow: "1",
        display: "flex",
        flexDirection: "column",
        alignItems: "end",
      }}
    >
      {!cartItem && (
        // (!!props.data.variant[props.index].price ||
        //   !!props.data.variant[props.index].unit)
        //  &&
        <div
          style={{
            width:
              props?.data?.variant?.length &&
              (!!props.data.variant[props.index].price ||
                !!props.data.variant[props.index].unit)
                ? props?.size === "large"
                  ? "150px"
                  : "70px"
                : "100%",
            color: editModeBhp
              ? "white"
              : props?.advanceCustomization?.accentColorContrast || "",
            background: editModeBhp
              ? "var(--ion-color-tertiary)"
              : props?.color === "white"
              ? "lightgray"
              : props?.advanceCustomization?.accentColor || "",
            fontSize: props?.size === "large" ? "1.2rem" : undefined,
          }}
          className={`add-to-cart-btn ${
            props.subscriptionType === "CATALOGUE"
              ? "add-to-cart-btn-catalogue"
              : ""
          }`}
          data-testid="add-to-cart-btn"
          onClick={(e) => {
            let { schoolId } = getSessionDetails();
            e.stopPropagation();
            if (editModeBhp) {
              history.push(
                props?.bhpEditLinks
                  ? props.bhpEditLinks.editProduct
                      .replace("%prodId%", `${props.id}`)
                      .replace("%SCHOOL_ID%", `${props.entityId}`)
                  : bhpEditLinks.editProduct
                      .replace("%prodId%", `${props.id}`)
                      .replace("%SCHOOL_ID%", `${props.entityId}`)
              );
              return;
            }
            if (props.buttonOverride && props.buttonOverride.onClick) {
              props.buttonOverride.onClick(props.id);
              return;
            }
            if (!props.isVarientMode && props.data.variant.length > 1) {
              props.OpenVarientModel();
            } else {
              if (props.subscriptionType === "CATALOGUE") return;
              props.addRemoveCartCallBack(
                "add",
                true,
                props.id,
                props.isVarientMode
                  ? props.data.variant[props.index].option
                  : "",
                props.data.variant[props.index].price
              );
            }
          }}
        >
          {!(props.subscriptionType === "CATALOGUE") && (
            <>
              <span
                style={{
                  fontSize: props?.size === "large" ? "1.2rem" : "0.8rem",
                }}
              >
                <IonIcon
                  icon={
                    editModeBhp
                      ? pencil
                      : props.buttonOverride && props.buttonOverride.icon
                      ? props.buttonOverride.icon
                      : add
                  }
                />
              </span>
              <span style={{ marginLeft: "5px" }}>
                {editModeBhp
                  ? "Edit"
                  : props.buttonOverride && props.buttonOverride.name
                  ? props.buttonOverride.name
                  : props.subscriptionType === "TIER-II"
                  ? "Order"
                  : "Request Info"}
              </span>
            </>
          )}
          {props?.subscriptionType === "CATALOGUE" && !!price && (
            <>{`${price}`}</>
          )}
        </div>
      )}

      {cartItem && props.subscriptionType !== "TIER-II" && requestCartItemJsx}
      {cartItem && props.subscriptionType === "TIER-II" && addCartItemJsx}
      {!props.isVarientMode &&
        !!props.data.variant?.length &&
        // !props.listModeListing &&
        props.data.variant.length > 1 && (
          <>
            <div
              style={{
                color:
                  props.subscriptionType === "CATALOGUE"
                    ? "var(--ion-color-brown)"
                    : "grey",
                fontSize: props?.size === "large" ? "0.7rem" : "0.5rem",
                textAlign: "center",
                padding: "2px",
                paddingBottom: "0",
              }}
            >
              {props.subscriptionType === "CATALOGUE"
                ? "+ Options"
                : "Customize"}
            </div>
          </>
        )}
    </div>
  );

  const hasPrice =
    !!props.data.variant?.length &&
    (!!props.data.variant[props.index].price ||
      !!props.data.variant[props.index].unit);

  const menuVariantJsx = (
    <div className="variant-menu-price-card">
      {props.data.variant?.map((el, idx) => {
        return (
          <div
            key={idx}
            style={{
              color: "var(--ion-color-medium)",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <div>
              {props.data.variant.length > 1 && (
                <span>{`${el.option} - `}</span>
              )}
            </div>
            <div
              style={{
                color: "var(--ion-color-bhp-footer)",
                fontWeight: "bold",
              }}
            >{`${el.price}`}</div>
          </div>
        );
      })}
    </div>
  );

  return (
    <>
      {!props.listModeListing && (
        <div
          className={props.isVarientMode ? "variant_list_wrapper" : ""}
          style={{ width: "100%" }}
        >
          {!!props.data?.variant &&
            (!props.isMarket || (props.isMarket && props.marketShowPrice)) && (
              <div
                className="product_card-right-bottom"
                style={{ padding: props?.disablePadding ? 0 : undefined }}
              >
                {!!props.variantName && (
                  <div
                    style={{
                      fontSize: "1rem",
                      textTransform: "capitalize",
                      fontWeight: "bold",
                      margin: "5px 0px 5px 0px",
                      color: "var(--ion-color-bhp-footer)",
                    }}
                  >
                    {props.variantName}
                  </div>
                )}
                <span
                  style={{
                    color: "var(--ion-color-tertiary-dark)",
                    fontWeight: "bold",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    flexDirection: !(props.isMarket && props.marketShowPrice)
                      ? "row-reverse"
                      : "row",
                  }}
                >
                  {!(props.isMarket && props.marketShowPrice) && buttonJsx}
                  {hasPrice && priceJsx}
                </span>
              </div>
            )}
        </div>
      )}
      {!!props.listModeListing &&
        props.subscriptionType !== "PHYSICAL-MENU" &&
        buttonJsx}
      {!!props.listModeListing &&
        props.subscriptionType === "PHYSICAL-MENU" &&
        !editModeBhp &&
        menuVariantJsx}
      {!!props.listModeListing &&
        props.subscriptionType === "PHYSICAL-MENU" &&
        editModeBhp && (
          <IonButton
            color="tertiary"
            size="small"
            onClick={() => {
              console.log("edit product : props =", props);
              history.push(
                props.bhpEditLinks.editProduct
                  .replace("%prodId%", `${props.data.id}`)
                  .replace("%SCHOOL_ID%", `${props.entityId}`)
              );
            }}
          >
            <IonIcon icon={pencil} />
          </IonButton>
        )}
      {/* {hasDiscount && !!props.listModeListing && (
        <div
          style={{
            position: "absolute",
            zIndex: "1000",
            top: "-5px",
            right: 0,
          }}
        >
          {discountJsx}
        </div>
      )} */}
    </>
  );
};

export default VariantPricing;
export { VariantPriceDisplay, VariantPricingSelModal };
